import * as React from 'react';

import { cn } from '../../../../utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
	type?: string;
	className?: string;
	hasErrors?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, hasErrors, ...props }, ref) => {
		return (
			<input
				className={cn(
					'flex-1 min-w-0 block w-full h-11 p-3 rounded text-base',
					hasErrors
						? 'text-error border-error placeholder:text-error focus:ring-error focus:border-error'
						: 'border-primaryBorder placeholder:text-disabledText focus:ring-primaryBrand focus:border-primaryBrand',
					className
				)}
				ref={ref}
				type={type}
				aria-invalid={hasErrors ? 'true' : 'false'}
				aria-errormessage={hasErrors ? `${props.name}-error` : ''}
				{...props}
			/>
		);
	}
);
